import { articles } from "@kiwicom/frontend-common/modules/SmartFAQ/services/SmartFAQDuck"

export const REINITIALIZE_FARE_TYPE = "REINITIALIZE_FARE_TYPE"

export const GET_FARE_TYPE_RULES = "GET_FARE_TYPE_RULES"
export const GET_FARE_TYPE_RULES_REQUEST = "GET_FARE_TYPE_RULES_REQUEST"
export const GET_FARE_TYPE_RULES_SUCCESS = "GET_FARE_TYPE_RULES_SUCCESS"
export const GET_FARE_TYPE_RULES_FAILURE = "GET_FARE_TYPE_RULES_FAILURE"

export const FARE_TYPES = Object.freeze({
  LEGACY: "legacy",
  SAVER: "saver",
  STANDARD: "standard",
  FLEXI: "flexi",
  REFUNDABLE: "refundable",
  KCG_FLEXI: "kcg_flexi",
})

export const UNBUNDLED_FARE_TYPE = Object.freeze({
  REBOOKABILITY: "rebookability",
  REFUNDABILITY: "refundability",
})

export const UNBUNDLED_FARE_TYPES_INFO = {
  [UNBUNDLED_FARE_TYPE.REBOOKABILITY]: {
    // @ts-expect-error: Flow to TS migration.
    tKey: __("booking.additional_services.upgrades.reservation_bill.flexibility_to_change"),
    article: articles.WHAT_IS_FLEXI_CHANGE,
  },
  [UNBUNDLED_FARE_TYPE.REFUNDABILITY]: {
    // @ts-expect-error: Flow to TS migration.
    tKey: __("booking.additional_services.upgrades.reservation_bill.flexibility_to_cancel"),
    article: articles.WHAT_IS_FLEXI_CANCEL,
  },
} as const

export const FARE_TYPES_REFUND_FORM_NAME = "fareTypesRefund"

export const FARE_TYPE_REFUND_DEADLINE_HOURS = 48
export const MISSED_DEADLINE_REFUND_DESCRIPTION =
  "PAX are aware that they will not get any refund. Please cancel all remaining PNR. Do not send any refund to PAX."
